<section fxLayout="row" fxFlexAlign="center center">
  <nav fxLayout="row" fxLayoutGap="16px">
    <a [ngClass]="{'active': nav.slug === 'how-it-works'}"
       fxLayoutAlign="center center"
       routerLink="/how-it-works">What is balikbayad?</a>
    <a [ngClass]="{'active': nav.slug === 'why-balikbayad'}"
       fxLayoutAlign="center center"
       routerLink="/why-balikbayad">Why balikbayad?</a>
    <a [ngClass]="{'active': nav.slug === 'getting-a-loan'}"
       fxLayoutAlign="center center"
       routerLink="/getting-a-loan">How to get the loan</a>
  </nav>
</section>
